/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Add_Marker_ButtonInputs */



/**
* | output |
* | --- |
* | "Add Marker" |
*
* @param {Markers_Add_Marker_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_add_marker_button = /** @type {((inputs?: Markers_Add_Marker_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Add_Marker_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar marcador")
	return /** @type {LocalizedString} */ ("Add Marker")
});